//#region src/utils/constants.ts
const SAFE_DECIMALS = 9;
const SAFELET_PER_SAFE = BigInt(1e9);
const MOVE_STDLIB_ADDRESS = "0x0000000000000000000000000000000000000000000000000000000000000001";
const SAFE_FRAMEWORK_ADDRESS = "0x0000000000000000000000000000000000000000000000000000000000000002";
const SAFE_SYSTEM_ADDRESS = "0x0000000000000000000000000000000000000000000000000000000000000003";
const SAFE_CLOCK_OBJECT_ID = "0x0000000000000000000000000000000000000000000000000000000000000006";
const SAFE_SYSTEM_MODULE_NAME = "safe_system";
const SAFE_TYPE_ARG = `${SAFE_FRAMEWORK_ADDRESS}::safe::SAFE`;
const SAFE_SYSTEM_STATE_OBJECT_ID = "0x0000000000000000000000000000000000000000000000000000000000000005";
const SAFE_RANDOM_OBJECT_ID = "0x0000000000000000000000000000000000000000000000000000000000000008";
const SAFE_COIN_REGISTRY_OBJECT_ID = "0x000000000000000000000000000000000000000000000000000000000000000c";
const SAFE_DENY_LIST_OBJECT_ID = "0x0000000000000000000000000000000000000000000000000000000000000403";
//#endregion
export { MOVE_STDLIB_ADDRESS, SAFELET_PER_SAFE, SAFE_CLOCK_OBJECT_ID, SAFE_COIN_REGISTRY_OBJECT_ID, SAFE_DECIMALS, SAFE_DENY_LIST_OBJECT_ID, SAFE_FRAMEWORK_ADDRESS, SAFE_RANDOM_OBJECT_ID, SAFE_SYSTEM_ADDRESS, SAFE_SYSTEM_MODULE_NAME, SAFE_SYSTEM_STATE_OBJECT_ID, SAFE_TYPE_ARG };

//# sourceMappingURL=constants.mjs.map